import { FC } from 'react';
import EventJsonLd from './json-ld';
import { SharingCardMeta } from './sharing-card';

export const url = 'https://www.lemon8-app.com/activity/referral-gifts';

export const Helmet: FC = () => {
  return (
    <>
      <SharingCardMeta />
      <EventJsonLd />
    </>
  );
};
